import styled from 'styled-components';

export const SidebarIcon = styled.i` ${({ theme }) => `
  font-size: ${theme.fontSize[3]};
`}`;
